import React from 'react';
import cn from 'classnames';

import SalonModal from 'components/dialog/SalonModal.component';
import Button from 'components/form/Button.component';
import Icon from 'components/generic/Icon.component';
import IconStatus from 'components/generic/IconStatus.component';
import useTip from 'hooks/useTip.hook';
import { useTranslation } from 'providers/GILT.provider';
import { useTheme } from 'providers/Theme.provider';
import fromAnyToBool from 'utils/converters/fromAnyToBool.util';

import CN from './Subscription.module.scss';

const Subscription = () => {
  const { isDarkMode } = useTheme();
  const { t } = useTranslation();

  const { val: isModalOpen, yay: showModal, nay: hideModal } = useTip(false);

  return (
    <div
      data-bem="Subscription"
      className={cn({
        [CN.component]: true,
        [CN.dark]: isDarkMode,
      })}
    >
      <div className={CN.container}>
        <div className={CN.flex}>
          <div className={CN.pageTitle}>{t('staffAndBusiness.subAndBilling.cancelSubscription.title')}</div>
          <div className={CN.subTitle}>{t('staffAndBusiness.subAndBilling.cancelSubscription.description')}</div>
        </div>
        <Button variant="alert" onClick={showModal}>
          <div className={CN.buttonGap}>{t('staffAndBusiness.subAndBilling.cancelSubscription.cancelButton')}</div>
        </Button>
      </div>

      {fromAnyToBool(isModalOpen) && (
        <SalonModal tag="Subscription__Modal" isOpen withFooter>
          <SalonModal.Header>
            <div className={CN.closeButtonContainer}>
              <Button variant="empty" onClick={hideModal}>
                <Icon variant="close" variantInvert />
              </Button>
            </div>
          </SalonModal.Header>
          <SalonModal.Body>
            <div className={CN.image}>
              <IconStatus variant="alert">
                <Icon variant="alert" />
              </IconStatus>
            </div>
            <div className={CN.modalContent}>
              <div className={CN.modalTitle}>{t('staffAndBusiness.subAndBilling.cancelSubscription.requestModalTitle')}</div>
              <span className={CN.modalText}>{t('staffAndBusiness.subAndBilling.cancelSubscription.requestModalDescription')}</span>
            </div>
          </SalonModal.Body>
          <SalonModal.Footer>
            <Button variant="primaryForce" onClick={hideModal}>
              <span className={CN.buttonSpace}>{t('common.buttons.ok')}</span>
            </Button>
          </SalonModal.Footer>
        </SalonModal>
      )}
    </div>
  );
};

export default Subscription;
